import { apiGet, wrappedApiGet, wrappedApiPut } from 'utils/http';
import { ClientAgreementType } from '@payer-admin-ui/api/src/clientagreements/models/ClientAgreementType';
import { ClientAgreementAcceptRequest } from '@payer-admin-ui/api/src/clientagreements/requests/ClientAgreementAcceptRequest';
import { ClientAgreementResponse } from '@payer-admin-ui/api/src/clientagreements/responses/ClientAgreementResponse';

const clientAgreementsAPI = {
  getAgreements: async (): Promise<ClientAgreementResponse[]> => {
    return wrappedApiGet<ClientAgreementResponse[]>('/v1/client-agreements').withObjectResponse();
  },

  getAgreement: async (agreementType: ClientAgreementType): Promise<ClientAgreementResponse | null> => {
    return apiGet(`/v1/client-agreements/${agreementType}`) as Promise<ClientAgreementResponse | null>;
  },

  acceptAgreement: async (
    agreementType: ClientAgreementType,
    acceptedVersion = 1,
  ): Promise<ClientAgreementResponse> => {
    const requestBody: ClientAgreementAcceptRequest = { agreementType, acceptedVersion };

    return wrappedApiPut<ClientAgreementResponse>('/v1/client-agreements', {
      body: requestBody,
    }).withObjectResponse();
  },
};

export { clientAgreementsAPI };
